// Material Dashboard 2 PRO React TS components
import MDInput from "components/MDInput";

// Declaring props types for FormField
interface Props {
  label?: string;
  variant?: "standard" | "outlined";
  [key: string]: any;
}

function FormField({
  label,
  variant,
  InputProps: restInputProps,
  multiline,
  sx,
  ...rest
}: Props): JSX.Element {
  const isMultiline = Boolean(multiline);

  const multilineSx = isMultiline
    ? {
        "& .MuiOutlinedInput-root": {
          height: "auto",
          alignItems: "flex-start",
        },
        "& .MuiOutlinedInput-input": {
          overflow: "auto",
          resize: "vertical",
        },
      }
    : {};

  return (
    <MDInput
      variant={variant}
      label={label}
      fullWidth
      InputLabelProps={{ shrink: true }}
      multiline={multiline}
      sx={{ ...multilineSx, ...sx }}
      {...rest}
      InputProps={{
        ...restInputProps,
        style: isMultiline
          ? {
              backgroundColor: "#fff",
              alignItems: "flex-start",
              height: "auto",
              minHeight: "unset",
              padding: "12px 14px",
              ...restInputProps?.style,
            }
          : {
              height: "52px",
              backgroundColor: "#fff",
              ...restInputProps?.style,
            },
      }}
    />
  );
}

export default FormField;

// Declaring default props for FormField
FormField.defaultProps = {
  variant: "outlined",
};
